<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="button-group">
    <button mat-raised-button color="primary" (click)="onCreateStockExchange()">
      <mat-icon>add</mat-icon>
      Add Stock Exchange
    </button>
  </div>
  <app-lookup-table
      [items]="stockExchanges()"
      (itemClick)="onItemSelected($event)"
      (editClick)="onEditStockExchange($event)"
      (deleteClick)="onDeleteStockExchange($event)"
      (itemSave)="onItemSave($event)"
      (itemAdd)="onItemAdd($event)">
    </app-lookup-table>
</div>
